module.exports = __webpack_public_path__ + "img/tile-rea1.be4f4dea.jpg";